import { BASKET_TYPES } from 'containers/OrderDetails/basketSlice'
import useWarehouseName from 'hooks/useWarehouseName'
import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import DeliveryItem from './DeliveryItem'
import ListItem from './ListItem'
import React from 'react'

interface ListProps {
  list: any[]
}

const List: React.FC<ListProps> = ({ list }) => {
  const { push, replace, goBack } = useHistory()
  const { t } = useTranslation('basket')
  const getName = useWarehouseName()

  return (
    <div className='basketPopup__list'>
      {list.map((data) => {
        if (data.type === BASKET_TYPES.shop && data.related) return null
        return <ListItem
          {...data}
          name={getName(data)}
          key={data.identifier}
          isOnlyOnePositionInTheBasket={list.length === 1}
        />
      })}
      <DeliveryItem />
      <button
        className='button --coupon'
        onClick={() => {
          if (list?.some(l => l.type === BASKET_TYPES.rent)) {
            push(window.location.pathname, LOCATION_STATES.popup('newMag'))
          } else if (window.location.pathname.includes('shop')) {
            goBack()
          } else {
            replace('/shop')
          }
        }}>
        <span className='--secFont'>+ {t('addAnotherOne')}</span>
      </button>
    </div>
  )
}

export default List